export const toMoneyText = (moneyParts) =>
  moneyParts.reduce((result, { value }) => result + value, '');
